module.exports = __webpack_public_path__ + "img/snow-3.a38ee695.svg";